import { Component, Input } from '@angular/core';

@Component({
    selector:'top-3-winners-stage-component',
    templateUrl:'./top-3-winners-stage.component.html',
    styleUrls:['./top-3-winners-stage.component.scss']
})
export class Top3WinnersStageComponent {
    @Input() top3Winners:Array<object|any>|any;
}